import { DatePicker } from '@/shared/components'
import { formatStoredDate } from './helpers'

type LicenseDateFieldsProps = {
  issueDate: string
  expirationDate: string
  today: string
  isIssueDateDisabled?: boolean
  isExpirationDateDisabled?: boolean
  onIssueDateChange: (value: string) => void
  onExpirationDateChange: (value: string) => void
}

export function LicenseDateFields({
  issueDate,
  expirationDate,
  today,
  isIssueDateDisabled = false,
  isExpirationDateDisabled = false,
  onIssueDateChange,
  onExpirationDateChange
}: LicenseDateFieldsProps) {
  return (
    <>
      <div
        className="animate-fade-in-up relative z-[11000]"
        style={{ animationDelay: '280ms' }}
      >
        <div className="w-full">
          <DatePicker
            label="Issue Date *"
            value={formatStoredDate(issueDate)}
            onChange={onIssueDateChange}
            placeholder="MM/DD/YYYY"
            max={today}
            disabled={isIssueDateDisabled}
          />
        </div>
      </div>

      <div
        className="animate-fade-in-up relative z-[10000]"
        style={{ animationDelay: '340ms' }}
      >
        <div className="w-full">
          <DatePicker
            label="Expiration Date *"
            value={formatStoredDate(expirationDate)}
            onChange={onExpirationDateChange}
            placeholder="MM/DD/YYYY"
            min={today}
            disabled={isExpirationDateDisabled}
          />
        </div>
      </div>
    </>
  )
}
